import React from "react";
import { Clock, Users, Award, Building2, PhoneCall } from "lucide-react";

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative bg-nsp-bg py-24 lg:py-32 overflow-hidden"
        >
            {/* Large watermark */}
            <div
                aria-hidden="true"
                className="absolute -top-10 right-0 lg:right-12 font-display text-[180px] lg:text-[280px] leading-none text-nsp-green/[0.04] select-none pointer-events-none"
            >
                NSP
            </div>

            <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 relative">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    {/* Text column */}
                    <div className="lg:col-span-7">
                        <div className="text-xs font-bold uppercase tracking-[0.3em] text-nsp-green mb-6 flex items-center gap-3">
                            <span className="w-8 h-px bg-nsp-green" />
                            Chi Siamo
                        </div>
                        <h2
                            data-testid="about-title"
                            className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[1] text-nsp-green tracking-tighter"
                        >
                            Una realtà
                            <br />
                            storica.
                            <br />
                            <span className="text-nsp-yellow [text-shadow:_2px_2px_0_#0a3b25]">
                                Tecnica, vera.
                            </span>
                        </h2>

                        <div className="mt-8 space-y-5 text-zinc-700 text-lg leading-relaxed max-w-2xl">
                            <p>
                                Nasciamo come braccio operativo di{" "}
                                <b className="text-nsp-green">BigMat Ediltutto</b>, riferimento
                                nell'edilizia del Lazio. Da anni mettiamo a disposizione di
                                professionisti, imprese e privati una flotta completa di
                                attrezzature da cantiere.
                            </p>
                            <p>
                                Il nostro lavoro non finisce con la consegna del mezzo. Offriamo{" "}
                                <b>assistenza all'avviamento, trasporto, lavaggio</b> e
                                consulenza tecnica. Uomini vicini al tuo lavoro che parlano la
                                tua stessa lingua.
                            </p>
                        </div>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <a
                                data-testid="about-whatsapp"
                                href="https://wa.me/393272237610"
                                target="_blank"
                                rel="noreferrer"
                                className="rounded-full bg-[#25D366] text-white px-6 py-3.5 font-bold uppercase tracking-widest text-xs flex items-center gap-2 hover:bg-[#1ebe5b] shadow-md active:scale-95 transition-transform"
                            >
                                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" aria-hidden="true">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
                                </svg>
                                Scrivici su WhatsApp
                            </a>
                            <a
                                data-testid="about-phone"
                                href="tel:3272237610"
                                className="rounded-full bg-white text-nsp-green border-2 border-nsp-green px-6 py-3.5 font-bold uppercase tracking-widest text-xs flex items-center gap-2 hover:bg-nsp-green hover:text-nsp-yellow transition-colors active:scale-95"
                            >
                                <PhoneCall className="w-4 h-4" /> 327 2237610
                            </a>
                        </div>

                        <div className="grid sm:grid-cols-2 gap-4 mt-10">
                            <AboutCard
                                icon={Award}
                                title="Esperienza storica"
                                text="Decenni nel settore edilizia del Lazio."
                            />
                            <AboutCard
                                icon={Users}
                                title="Team specializzato"
                                text="Consulenti che ti seguono ad ogni fase."
                            />
                            <AboutCard
                                icon={Building2}
                                title="Sede operativa Sabina"
                                text="Salaria Vecchia 31, Osteria Nuova di Poggio Moiano (RI)."
                            />
                            <AboutCard
                                icon={Clock}
                                title="Servizio rapido"
                                text="Preventivi e disponibilità immediata."
                            />
                        </div>
                    </div>

                    {/* Image column */}
                    <div className="lg:col-span-5">
                        <div className="relative">
                            <img
                                src="https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=900&q=80"
                                alt="Operatore in cantiere"
                                className="w-full aspect-[4/5] object-cover"
                            />
                            <div className="absolute -bottom-6 -left-6 bg-nsp-yellow p-6 rounded-2xl shadow-lg hidden lg:block">
                                <div className="font-display text-nsp-green text-5xl leading-none">
                                    360°
                                </div>
                                <div className="text-nsp-green text-xs font-bold uppercase tracking-wider mt-2">
                                    Noleggio completo
                                </div>
                            </div>
                            <div className="absolute -top-6 -right-6 bg-nsp-green text-white p-4 hidden lg:block">
                                <div className="text-xs uppercase tracking-[0.2em] text-nsp-yellow font-bold">
                                    Dal 1985
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const AboutCard = ({ icon: Icon, title, text }) => (
    <div className="bg-white border border-nsp-border p-5 hover:border-nsp-green transition-colors">
        <Icon className="w-7 h-7 text-nsp-green mb-3" strokeWidth={2} />
        <div className="font-bold text-nsp-green text-sm uppercase tracking-wide">{title}</div>
        <div className="text-zinc-600 text-sm mt-1">{text}</div>
    </div>
);

export default About;
